import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import UserCard from "components/Cards/UserCard";
import UserDetail from "components/Cards/UserDetail";
import UserForm from "components/Forms/UserForm";
import ToggleDetail from "components/ToggleDetail";
import { isBrowser } from "react-device-detect";
import { connect } from "react-redux";
import { get } from "services";
import { SetHasPersonalData } from "redux/actions/hasPersonalDataReducerActions";
import { SetHasVehicle } from "redux/actions/hasVehicleDataActions";
import { SetHasFamilyStructure } from "redux/actions/hasFamilyStructureDataActions";
import { SetHasEducation } from "redux/actions/hasEducationDataActions";
import { SetHasLanguage } from "redux/actions/hasLanguageDataActions";
import { SetHasKnowledge } from "redux/actions/hasKnowledgeDataActions";
import { SetHasExperience } from "redux/actions/hasExperienceDataActions";
import { SetHasRefenceData } from "redux/actions/hasReferenceDataActions";
import { SetHasJobInformation } from "redux/actions/hasJobInformationDataActions";
import { SetHasAttachment } from "redux/actions/hasAttachmentDataActions";
import { useHistory } from "react-router";
import Navigation from "components/Navigation";
import { SetUser } from "redux/actions/userActions";
import { SetLoggedIn } from "redux/actions/isLoggedInActions";
import { SetIsRequiredModule } from "redux/actions/isRequiredModuleActions";
import { addToken } from "services";

const modulePadding = isBrowser ? "" : "";

const HomeModule = ({
  user,
  SetUser,
  SetLoggedIn,
  SetHasPersonalData,
  SetHasVehicle,
  SetHasFamilyStructure,
  SetHasEducation,
  SetHasLanguage,
  SetHasKnowledge,
  SetHasExperience,
  SetHasRefenceData,
  SetHasJobInformation,
  SetHasAttachment,
  SetIsRequiredModule,
}) => {
  const [showDetail, setShowDetail] = useState(true);
  const [nextUrl, setNextUrl] = useState("/education");
  const history = useHistory();

  useEffect(() => {
    (async function mounted() {
      if (user.esEmpleado) {
        setNextUrl("/familyStructure");
      }

      if (
        user.persona &&
        user.persona.fechaNacimiento &&
        user.persona.fechaNacimiento != "0001-01-01T00:00:00"
      ) {
        SetHasPersonalData(true);
        setShowDetail(true);
      } else {
        SetHasPersonalData(false);
        setShowDetail(false);
      }

      try {
        //debugger;
        addToken();
        const response = await get("Usuario/IsValidToken");

        if (
          response &&
          response.data &&
          response.data.message == "Authorized"
        ) {
          get(`PersonaVehiculo/HasData/${user.persona.id}`).then((response) => {
            SetHasVehicle(response.data);
          });

          get(`PersonaFamilia/HasData/${user.persona.id}`).then((response) => {
            SetHasFamilyStructure(response.data);
          });

          get(`PersonaEducacion/HasData/${user.persona.id}`).then(
            (response) => {
              SetHasEducation(response.data);
            }
          );

          get(`PersonaIdioma/HasData/${user.persona.id}`).then((response) => {
            SetHasLanguage(response.data);
          });

          get(`PersonaConocimiento/HasData/${user.persona.id}`).then(
            (response) => {
              SetHasKnowledge(response.data);
            }
          );

          get(`PersonaExperiencia/HasData/${user.persona.id}`).then(
            (response) => {
              SetHasExperience(response.data);
            }
          );

          get(`PersonaReferencia/HasData/${user.persona.id}`).then(
            (response) => {
              SetHasRefenceData(response.data);
            }
          );

          get(`SolicitudEmpleo/HasData/${user.persona.id}`).then((response) => {
            SetHasJobInformation(response.data);
          });

          get(`PersonaDocumento/HasData/${user.persona.id}`).then(
            (response) => {
              SetHasAttachment(response.data);
            }
          );
        } else {
          logOut();
        }
      } catch (error) {
        logOut();
      }
    })();
  }, []);

  const logOut = () => {
    SetUser({});
    SetLoggedIn(false);
    SetHasPersonalData(false);
    SetHasVehicle(false);
    SetHasFamilyStructure(false);
    SetHasEducation(false);
    SetHasLanguage(false);
    SetHasKnowledge(false);
    SetHasExperience(false);
    SetHasRefenceData(false);
    SetHasJobInformation(false);
    SetHasAttachment(false);
    SetIsRequiredModule(false);
    localStorage.removeItem("currentUser-ARS");
    localStorage.removeItem("token-ARS");

    history.push({
      pathname: "/",
      state: {},
    });
  };

  return (
    <>
      <div className={modulePadding}>
        <ToggleDetail
          initState={showDetail}
          onToggleDetail={setShowDetail}
          label="Datos personales"
        />
        {showDetail ? (
          <div>
            <UserCard />
            <br />
            <UserDetail />
            <br />
            <Navigation continueUrl={nextUrl} />
          </div>
        ) : (
          <div>
            <UserForm />
          </div>
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    SetUser: (user) => dispatch(SetUser(user)),
    SetLoggedIn: (value) => dispatch(SetLoggedIn(value)),
    SetHasPersonalData: (value) => dispatch(SetHasPersonalData(value)),
    SetHasVehicle: (value) => dispatch(SetHasVehicle(value)),
    SetHasFamilyStructure: (value) => dispatch(SetHasFamilyStructure(value)),
    SetHasEducation: (value) => dispatch(SetHasEducation(value)),
    SetHasLanguage: (value) => dispatch(SetHasLanguage(value)),
    SetHasKnowledge: (value) => dispatch(SetHasKnowledge(value)),
    SetHasExperience: (value) => dispatch(SetHasExperience(value)),
    SetHasRefenceData: (value) => dispatch(SetHasRefenceData(value)),
    SetHasJobInformation: (value) => dispatch(SetHasJobInformation(value)),
    SetHasAttachment: (value) => dispatch(SetHasAttachment(value)),
    SetIsRequiredModule: (value) => dispatch(SetIsRequiredModule(value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HomeModule);
